import { render, staticRenderFns } from "./titleAdmin.vue?vue&type=template&id=37f8d1e4&scoped=true&"
import script from "./titleAdmin.vue?vue&type=script&lang=js&"
export * from "./titleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./titleAdmin.vue?vue&type=style&index=0&id=37f8d1e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8d1e4",
  null
  
)

export default component.exports